let ShareKakaoStorySimpleUrlLink = function( url ){
  url = url || encodeURIComponent(location.href);
  let kakaoStoryShareUrl = 'https://story.kakao.com/share?url=';
  let options = 'width=530, height=480, resizable=no, scrollbars=no, status=no';
  window.open( kakaoStoryShareUrl + url, 'kakaoStoryShare', options );
};

export default ShareKakaoStorySimpleUrlLink;
